export const LABEL_PROMO_TYPES = {
  FREE_ITEM: 'free-item',
  DISCOUNT: 'discount',
  CASHBACK: 'cashback',
  MULTI_FREE_ITEM: 'multi-free-item',
  FREE_GOODS: 'free-goods',
};
